import React, {Component} from "react";
import {injectIntl} from "react-intl";

class DriveIn extends Component {

  onDriveInSelect = () => {
    const {selected, onSelect, selectable} = this.props;
    if (!selected && onSelect && selectable) {
      onSelect();
    }
  };

  render() {
    const {intl: {formatMessage}, selected} = this.props;
    const selectedCss = selected === true ? undefined : "choice-card--unselected";

    return (
      <div>
        <div className={["choice-card", selectedCss].join(' ')} onClick={this.onDriveInSelect}>
          <header className="choice-card__header">
            <h4 className="choice-card__title">{formatMessage({id:'appointment.detail.reception.drivein.title'})}</h4>
          </header>
          <div className="choice-card__body">
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(DriveIn)
